/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_BLACKLIST_ORIGINATORS_REQUEST]: state => {
    state.loadingBlacklistOriginators = true;
    state.loadingBlacklistOriginatorsSucceeded = false;
    state.loadingBlacklistOriginatorsFailed = false;
  },

  [types.GET_BLACKLIST_ORIGINATORS_SUCCESS]: (state, data) => {
    state.loadingBlacklistOriginators = false;
    state.loadingBlacklistOriginatorsSucceeded = true;
    state.blacklistedOriginators = data.results;
    if (data.results != null) {
      state.blacklistedOriginators = state.blacklistedOriginators.map(originator => {
        if (originator.type === 'whatsapp') {
          originator.originator = originator.originator.split('@')[0];
        }
        return originator;
      });
    }
  },

  [types.GET_BLACKLIST_ORIGINATORS_FAILURE]: (state, error) => {
    state.loadingBlacklistOriginators = false;
    state.loadingBlacklistOriginatorsSucceeded = false;
    state.loadingBlacklistOriginatorsFailed = true;
    state.loadingBlacklistOriginatorsError = error;
  },

  [types.CREATE_BLACKLIST_ORIGINATOR_REQUEST]: state => {
    state.creatingBlacklistOriginator = true;
    state.creatingBlacklistOriginatorSucceeded = false;
    state.creatingBlacklistOriginatorFailed = false;
  },

  [types.CREATE_BLACKLIST_ORIGINATOR_SUCCESS]: (state, data) => {
    state.creatingBlacklistOriginator = false;
    state.creatingBlacklistOriginatorSucceeded = true;
    state.blacklistedOriginators.splice(0, 0, data);
    if (data != null) {
      state.blacklistedOriginators = state.blacklistedOriginators.map(originator => {
        if (originator.type === 'whatsapp') {
          originator.originator = originator.originator.split('@')[0];
        }
        return originator;
      });
    }
  },

  [types.CREATE_BLACKLIST_ORIGINATOR_FAILURE]: (state, error) => {
    state.creatingBlacklistOriginator = false;
    state.creatingBlacklistOriginatorFailed = true;
    state.creatingBlacklistOriginatorError = error;
  },

  [types.DELETE_BLACKLIST_ORIGINATOR_REQUEST]: state => {
    state.deletingBlacklistOriginator = true;
    state.deletingBlacklistOriginatorSucceeded = false;
    state.deletingBlacklistOriginatorFailed = false;
  },

  [types.DELETE_BLACKLIST_ORIGINATOR_SUCCESS]: (state, id) => {
    state.deletingBlacklistOriginator = false;
    state.deletingBlacklistOriginatorSucceeded = true;
    state.blacklistedOriginators.splice(
      state.blacklistedOriginators.findIndex(x => x.id === id),
      1,
    );
  },

  [types.DELETE_BLACKLIST_ORIGINATOR_FAILURE]: (state, error) => {
    state.deletingBlacklistOriginator = false;
    state.deletingBlacklistOriginatorFailed = true;
    state.deletingBlacklistOriginatorError = error;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/blacklist/mutations.js